import { render, staticRenderFns } from "./paperaddr.vue?vue&type=template&id=edaa1062&scoped=true&"
import script from "./paperaddr.vue?vue&type=script&lang=js&"
export * from "./paperaddr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaa1062",
  null
  
)

export default component.exports